"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const FileProcessingService_1 = __importStar(require("./FileProcessingService"));
const ValidationService_1 = __importStar(require("./ValidationService"));
const TrainingApiService_1 = __importStar(require("./TrainingApiService"));
const ManualDataService_1 = __importStar(require("./ManualDataService"));
let TrainerService = class TrainerService extends client_1.RWSService {
    constructor(fileProcessingService, validationService, trainingApiService, manualDataService) {
        super();
        this.fileProcessingService = fileProcessingService;
        this.validationService = validationService;
        this.trainingApiService = trainingApiService;
        this.manualDataService = manualDataService;
    }
    // File processing methods
    async uploadFile(file) {
        return this.fileProcessingService.uploadFile(file);
    }
    async validateCSV(content) {
        const data = await this.fileProcessingService.parseCSV(content);
        const validation = this.validationService.validateData(data);
        return { data, validation };
    }
    exportToCSV(data) {
        return this.fileProcessingService.exportToCSV(data);
    }
    // Validation methods
    validateData(data) {
        return this.validationService.validateData(data);
    }
    calculateDataStatistics(data) {
        return this.validationService.calculateDataStatistics(data);
    }
    // Training API methods
    async startTraining(config, data) {
        return this.trainingApiService.startTraining(config, data);
    }
    async getTrainingStatus(trainingId) {
        return this.trainingApiService.getTrainingStatus(trainingId);
    }
    async cancelTraining(trainingId) {
        return this.trainingApiService.cancelTraining(trainingId);
    }
    // Manual data methods
    createEmptyEntry() {
        return this.manualDataService.createEmptyEntry();
    }
    addManualEntry(data, entry) {
        return this.manualDataService.addEntry(data, entry);
    }
    updateManualEntry(data, index, entry) {
        return this.manualDataService.updateEntry(data, index, entry);
    }
    removeManualEntry(data, index) {
        return this.manualDataService.removeEntry(data, index);
    }
    duplicateManualEntry(data, index) {
        return this.manualDataService.duplicateEntry(data, index);
    }
    searchManualEntries(data, query) {
        return this.manualDataService.searchEntries(data, query);
    }
    getManualDataCategories(data) {
        return this.manualDataService.getCategories(data);
    }
    importFromTemplate(template) {
        return this.manualDataService.importFromTemplate(template);
    }
};
exports.TrainerServiceInstance = TrainerService;
exports.TrainerServiceInstance = TrainerService = __decorate([
    __param(0, FileProcessingService_1.default),
    __param(1, ValidationService_1.default),
    __param(2, TrainingApiService_1.default),
    __param(3, ManualDataService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof FileProcessingService_1.FileProcessingServiceInstance !== "undefined" && FileProcessingService_1.FileProcessingServiceInstance) === "function" ? _a : Object, typeof (_b = typeof ValidationService_1.ValidationServiceInstance !== "undefined" && ValidationService_1.ValidationServiceInstance) === "function" ? _b : Object, typeof (_c = typeof TrainingApiService_1.TrainingApiServiceInstance !== "undefined" && TrainingApiService_1.TrainingApiServiceInstance) === "function" ? _c : Object, typeof (_d = typeof ManualDataService_1.ManualDataServiceInstance !== "undefined" && ManualDataService_1.ManualDataServiceInstance) === "function" ? _d : Object])
], TrainerService);
exports.default = TrainerService.getSingleton();
